import { useContext } from 'react';

import { DateField, Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { WildCardRouteContext } from 'src/context/WildCardRoute/WildCardRouteContext';

import { ComponentProps } from 'src/lib/ComponentProps';

import { isClinicalTopic } from '../../../utils/isTemplate';

import styles from './ContentOverviewQualityAssuranceStatement.module.css';

type ContentOverviewQualityAssuranceStatementProps = ComponentProps & {
	fields: {
		QualityAssuranceStatement: Field<string>;
		LastReviewedLabel?: Field<string>;
		DateOfLastQualityAssuranceReview?: Field<Date>;
	};
};

export default function ContentOverviewQualityAssuranceStatement(props: ContentOverviewQualityAssuranceStatementProps): JSX.Element {
	const WildCardRoute = useContext(WildCardRouteContext);

	if (
		isClinicalTopic(WildCardRoute?.wildCardItemInfo?.TemplateId) ||
		!props.fields.QualityAssuranceStatement ||
		!props.fields.QualityAssuranceStatement.value
	) {
		return <></>;
	}

	return (
		<section className="maxWidth maxHeight" data-display-pdf-download>
			<div className={styles.overviewQualityAssuranceStatementContainer}>
				<Text tag="h1" field={props.fields.QualityAssuranceStatement} className={styles.overviewQualityAssuranceStatementContainerText} />
				{props.fields.DateOfLastQualityAssuranceReview &&
					new Date(props.fields.DateOfLastQualityAssuranceReview?.value) > new Date('1900-01-01') && (
						<p className={styles.lastReviewedDate}>
							<Text field={props.fields.LastReviewedLabel} />
							<DateField
								field={props.fields.DateOfLastQualityAssuranceReview}
								render={(date: Date) => date && date.toLocaleDateString('en-GB')}
							/>
						</p>
					)}
			</div>
		</section>
	);
}
